// extracted by mini-css-extract-plugin
module.exports = {"root":"LanguageSwitcher_root__3Mev9 Drawer_box__3GC_l"};